import _ from 'lodash';

import shareholderTypes from 'Constants/shareholder-types';

export const someRegisteredShareholder = (shareholders) => _.some(shareholders, (shareholder) => shareholder.shareholderType === shareholderTypes.REGISTERED);
